export default {
    init(){
        $(".video-play").click(function () {
            $('.video-cont .video').each(function (item) {
                $('.video-cont .video-play').show();
                $('.video')[item].pause();
            })
            $(this).parent().find('.video')[0].play();
            $(this).toggle();
        });

        $('.video').click(function () {
            $(this).parent().find('.video')[0].pause();
            $(this).parent().find('.video-play').toggle();
        });

        $('#js-modal__mask,#js-modal-video__close').click(function (e) {
            $('#js-modal-video').toggle();
            $("#js-video")[0].pause();
        });

        $('.play-icon').click(function () {
            $('#js-video source').attr('src', $(this).data("video"));
            $('#js-video').attr('poster', $(this).data("poster"));
            $("#js-video")[0].load();
            $("#js-video")[0].play();
            $('#js-modal-video').toggle();
        })


    }
}



// WEBPACK FOOTER //
// ./src/pages/index/video.js